import React from 'react';
import { IoMdArrowDropdown } from 'react-icons/io';
import { FaSortAmountUpAlt, FaSortAmountDownAlt, FaEyeSlash } from 'react-icons/fa';

/**
 * DropdownComponent (Field Header Dropdown)
 * 
 * Dropdown menu displayed in datatable column headers providing options to:
 * - Sort A to Z and Z to A for text fields
 * - Hide column from view (disabled for primary fields)
 * Calls handler functions to apply sort or hide actions via parent props.
 * 
 * @param {Object} props - Component props with handler functions
 * @param {Object} props.field - Field object with actualName and type
 * @param {boolean} props.primary - Whether this is a primary/non-hideable field
 * @returns {JSX.Element} Column header dropdown menu with actions
 */
import { NavDropdown } from 'react-bootstrap';
import Styles from './dropdown.css';

import { handleFieldHide, handleFieldSort } from "../../utils/helpers";
import "./dropdown.css";

const DropdownComponent = ({ props, field, primary }) => {
  return (
    <>
      <NavDropdown
        align="end"
        className="sort-navbardropdown"
        title={<IoMdArrowDropdown className="sort-navbaricon" />}
        id="basic-nav-dropdown"
        style={{ height: "100%" }}
      >
        <NavDropdown.Item
          onClick={() => handleFieldSort(props, field, " Sort A to Z")}
          className="sort-navbardropdownitem"
          id="sort-navbaractive"
        >
          <FaSortAmountDownAlt /> Sort A to Z
        </NavDropdown.Item>
        <NavDropdown.Item
          onClick={() => handleFieldSort(props, field, " Sort Z to A")}
          className="sort-navbardropdownitem"
          id="sort-navbaractive"
        >
          <FaSortAmountUpAlt /> Sort Z to A
        </NavDropdown.Item>
        <NavDropdown.Item
          onClick={() => handleFieldHide(props, field)}
          disabled={primary}
          className={primary ? "disabled" : "sort-navbardropdownitem"}
          id="sort-navbaractive"
        >
          <div
            data-tip={
              primary &&
              "Hiding this field is disabled because it is a primary field"
            }
          >
            <FaEyeSlash /> Hide Field
          </div>
        </NavDropdown.Item>
      </NavDropdown>
    </>
  );
};

export default DropdownComponent;
